(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loved-by-customers-testimonials"] && !Shopify.designMode) return;
  try {
    
  const initializeLovedTestimonials = (scope = document) => {
    scope.querySelectorAll('.loved-testimonials').forEach((section) => {
      if (section.dataset.paginationReady === 'true') return;

      const slider = section.querySelector('.loved-testimonials__grid');
      const cards = Array.from(section.querySelectorAll('.loved-testimonials__card'));
      const buttons = Array.from(section.querySelectorAll('.loved-testimonials__pagination-button'));

      if (!slider || cards.length < 2 || buttons.length !== cards.length) return;

      section.dataset.paginationReady = 'true';

      const setActiveSlide = (index) => {
        buttons.forEach((button, buttonIndex) => {
          const isActive = buttonIndex === index;
          button.classList.toggle('is-active', isActive);

          if (isActive) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });
      };

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => {
          cards[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
      });

      const observer = new IntersectionObserver((entries) => {
        const mostVisibleCard = entries
          .filter((entry) => entry.isIntersecting)
          .sort((first, second) => second.intersectionRatio - first.intersectionRatio)[0];

        if (!mostVisibleCard) return;

        const activeIndex = cards.indexOf(mostVisibleCard.target);
        if (activeIndex >= 0) setActiveSlide(activeIndex);
      }, {
        root: slider,
        threshold: [0.5, 0.75, 1]
      });

      cards.forEach((card) => observer.observe(card));
    });
  };

  initializeLovedTestimonials();

  document.addEventListener('shopify:section:load', (event) => {
    initializeLovedTestimonials(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
